import React from "react";
import { useState, useEffect } from "react";
import { ThemeProvider, useThemeContext } from "@odl/core";
import { Box, Container, Typography } from "@mui/material";
import { AppHeader, TabPanel } from "./components/layout/AppHeader";
import { FeaturesTab } from "./components/features/FeaturesTab";
import { TimelineTab } from "./components/timeline/TimelineTab";
import { TeamTab } from "./components/team/TeamTab";

function App() {
  const { mode } = useThemeContext();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tabValue]);

  return (
    <React.StrictMode>
      <ThemeProvider mode={mode}>
        <Box
          sx={{
            minHeight: "100vh",
            bgcolor: "background.default",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            top: "0",
            left: "0",
          }}
        >
          <AppHeader value={tabValue} onChange={handleTabChange} />

          <Container maxWidth="lg" sx={{ flexGrow: 1, px: { xs: 0, sm: 3 } }}>
            <TabPanel value={tabValue} index={0}>
              <FeaturesTab />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <TimelineTab />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <TeamTab />
            </TabPanel>
          </Container>

          {/* Footer */}
          <Box
            component="footer"
            sx={{
              py: 2,
              px: 3,
              borderTop: 1,
              borderColor: "background.default",
              bgcolor: "background.paper",
            }}
          >
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: "0.8rem",
                textAlign: "center",
              }}
            >
              {new Date().getFullYear()}{" "}
              {new Date().getMonth() + 1 >= 4 ? "April" : "March"} 2026 |{" "}
              {new Date().getMonth() + 1 >= 4 ? "11" : "10"} months |{" "}
              {new Date().getMonth() + 1 >= 4 ? "Go-Live" : "Development"}
            </Typography>
          </Box>
        </Box>
      </ThemeProvider>
    </React.StrictMode>
  );
}

export default App;
